/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { CommonKeyCombinations } from "../../common/KeyCombinations";
import { IEditor } from "../../IEditor";
import { termsEditorEndpointEditor } from "../../terms/endpointEditor";

export function registerKeyBindings(dc: IEditor): void {
	const viewSvc = dc.get("viewService");
	const keyBindingSvc = dc.get("keyBindingService");

	keyBindingSvc.register({
		id: "endpointEditor.edit.toggleLeftPanel",
		commandId: "endpointEditor.edit.toggleLeftPanel",
		label: termsEditorEndpointEditor.commands.toggleLeftPanel,
		keys: CommonKeyCombinations.toggleLeftPanel,
		when: () => viewSvc.isViewActive("endpointEditor.edit")
	});

	keyBindingSvc.register({
		id: "endpointEditor.edit.toggleRightPanel",
		commandId: "endpointEditor.edit.toggleRightPanel",
		label: termsEditorEndpointEditor.commands.toggleRightPanel,
		keys: CommonKeyCombinations.toggleRightPanel,
		when: () => viewSvc.isViewActive("endpointEditor.edit")
	});

	keyBindingSvc.register({
		id: "endpointEditor.edit.hideAllPanels",
		commandId: "endpointEditor.edit.hideAllPanels",
		label: termsEditorEndpointEditor.commands.hideAllPanels,
		keys: CommonKeyCombinations.hideAllPanels,
		when: () => viewSvc.isViewActive("endpointEditor.edit")
	});

	keyBindingSvc.register({
		id: "endpointEditor.edit.toggleConsole",
		commandId: "endpointEditor.edit.toggleConsole",
		label: termsEditorEndpointEditor.commands.toggleConsole,
		keys: CommonKeyCombinations.toggleConsole,
		when: () => viewSvc.isViewActive("endpointEditor.edit")
	});

	keyBindingSvc.register({
		id: "endpointEditor.edit.saveResource",
		label: termsEditorEndpointEditor.commands.saveResource,
		commandId: "endpointEditor.edit.saveResource",
		keys: CommonKeyCombinations.save,
		when: () => viewSvc.isViewActive("endpointEditor.edit")
	});

	keyBindingSvc.register({
		id: "endpointEditor.edit.undo",
		label: termsEditorEndpointEditor.commands.undo,
		commandId: "endpointEditor.edit.undo",
		keys: CommonKeyCombinations.undo,
		when: () => {
			if (viewSvc.isViewActive("endpointEditor.edit")) {
				return viewSvc.hasModifiedViews();
			}
		}
	});

	keyBindingSvc.register({
		id: "endpointEditor.edit.redo",
		label: termsEditorEndpointEditor.commands.redo,
		commandId: "endpointEditor.edit.redo",
		keys: CommonKeyCombinations.redo,
		when: () => {
			if (viewSvc.isViewActive("endpointEditor.edit")) {
				return viewSvc.hasModifiedViews();
			}
		}
	});
}
